import reset from 'styled-reset'
import { createGlobalStyle } from 'styled-components'
import { Fonts } from 'src/styles/font/Fonts'
import { Colors } from './color'

interface GlobalStylesProps {
  $isWeb?: boolean
}

const GlobalStyles = createGlobalStyle<GlobalStylesProps>`
  ${reset};
  ${Fonts};
  ${Colors};
  

  * {
    margin: 0;
    padding: 0;
    color: var(--black-100);
    font-family: ${({ theme }) => theme.fontFamily};
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6, a, br, p, span, strong, ul, li {
    font-family: ${({ theme }) => theme.fontFamily};
  }

  :root {
    -webkit-tap-highlight-color: transparent;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    cursor: default;
    line-height: 1.4;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  html,
  body {
    position: relative;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  button {
    background: none;
    border: 0;
    cursor: pointer;
    user-select: none;
  }

  :where(a) {
    text-decoration: none;
    user-select: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  :where(input, button, select, textarea) {
    border-radius: 0;
    border: none;
    background: 0 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: 0;
    text-decoration: none;
    cursor: pointer;
    -webkit-text-size-adjust: none;
  }

  :where(input[type=radio],input[type=checkbox]) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-transition: background-color 9999s ease-out;
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
    -webkit-text-fill-color: #000 !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  textarea {
    resize: none;
  }

  //Scrollbar Custom
  ::-webkit-scrollbar {
    width: 1rem;
    position: absolute;
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #eee;
    border-radius: 1.25rem;
    border: 0.375rem solid transparent;
    background-clip: content-box;
  }
  //Google recaptcha hidden 처리
  .grecaptcha-badge {
    visibility: hidden !important;
  }
`

export default GlobalStyles
